export const selectOptionsVomPaymentHistory = [
  "No late payments",
  "History of late payments",
  "Includes default interest",
  "Indicates forebearance",
];
